const MAX_PATHS = 20;

export const validatePaths = (body) => {
    const paths = body?.paths;

    if (!Array.isArray(paths) || paths.length === 0) {
        return { error: 'paths must be a non-empty array' };
    }

    if (paths.length > MAX_PATHS) {
        return { error: `at most ${MAX_PATHS} paths per call` };
    }

    const badIndex = paths.findIndex(
        (path) =>
            typeof path !== 'string' ||
            !path.startsWith('/') ||
            path.includes('//') ||
            path.includes('?') ||
            path.includes('#')
    );

    if (badIndex !== -1) {
        return { error: `paths[${badIndex}] is not a valid path` };
    }

    return { paths };
};

export const profilePaths = (slug) =>
    slug ? [`/${slug}`, `/${slug}/media-coverage`] : [];

// Academy guides are PDFs in this profile's Media Pack (utils/academy.js).
export const ACADEMY_PROFILE = 'newspage';

// A Media Pack file shows on the profile, and on /academy for the Academy profile.
export const filePaths = (slug) => [
    ...profilePaths(slug),
    ...(slug === ACADEMY_PROFILE ? ['/academy'] : []),
];

// The deadline passing changes what the page renders with no save event behind
// it, so the window has to close around that moment rather than after it.
export const alertRevalidate = (deadline) => {
    const secondsLeft = Math.round(
        (new Date(deadline).getTime() - Date.now()) / 1000
    );
    return secondsLeft > 0 ? Math.min(Math.max(secondsLeft, 60), 3600) : 86400;
};

export const revalidatePaths = (paths) => {
    const unique = [...new Set((paths || []).filter(Boolean))];

    if (typeof window === 'undefined' || unique.length === 0) {
        return;
    }

    fetch('/api/revalidate', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ paths: unique }),
    })
        .then((res) => {
            if (!res.ok) {
                console.warn(`revalidate failed: ${res.status}`, unique);
            }
        })
        .catch((err) => console.warn('revalidate failed', err));
};
